import { makeStyles } from '@material-ui/core/styles';

import { RiFileLine } from '@remixicon/react';

import { Text } from '@backstage/ui';

import {
  type ToolGroupEntry,
  createToolExtension,
} from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'var(--bui-space-2)',
    padding: 'var(--bui-space-2) var(--bui-space-3)',
    backgroundColor: 'var(--bui-bg-surface-2)',
    borderRadius: 'var(--bui-radius-2)',
  },
  icon: {
    marginTop: 2,
    flexShrink: 0,
    color: 'var(--bui-fg-secondary)',
  },
});

const CreateDocumentToolRenderer = ({ entry }: { entry: ToolGroupEntry }) => {
  const classes = useStyles();

  if (entry.result) {
    let title = 'Document created';
    try {
      const data = JSON.parse(entry.result.content);
      if (data.displayName) {
        title = data.displayName;
      }
    } catch {
      // ignore
    }
    return (
      <div className={classes.root}>
        <RiFileLine size={16} className={classes.icon} />
        <Text variant="body-small">
          Created: <strong>{title}</strong>
        </Text>
      </div>
    );
  }

  const input = entry.input as { title?: string } | undefined;
  const title = input?.title ?? 'Untitled document';
  return (
    <div className={classes.root}>
      <RiFileLine size={16} className={classes.icon} />
      <Text variant="body-small">
        Creating document: <strong>{title}</strong>
      </Text>
    </div>
  );
};

export const CreateDocumentToolExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'create-document',
    predicate: tool => tool === 'create_document',
    icon: RiFileLine,
    display: 'prominent',
    render: () => null,
    renderTool: entry => <CreateDocumentToolRenderer entry={entry} />,
  }),
);
